module.exports = __webpack_public_path__ + "img/12_26@3x.d3127709.png";